import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Stream from 'flarum/common/utils/Stream';
import TypeFactory from '../types/TypeFactory';
import sortFields from '../../common/utils/sortFields';
export default class ProfilePane extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "answers", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  view() {
    return m("div", {
      class: "Masquerade-Bio"
    }, m("div", {
      class: "Fields"
    }, sortFields(app.store.all('masquerade-fields')).map(field => {
      const answer = this.answers.find(a => a.field()?.id() === field.id());
      return this.field(field, answer?.content() || null);
    })));
  }
  field(field, content) {
    const type = TypeFactory.typeForField({
      field,
      stream: Stream(content || '')
    });
    return type.answerField();
  }
  async load() {
    const userId = this.attrs.user.id();
    if (!userId) return;
    const answers = this.attrs.user.masqueradeAnswers();
    if (answers) {
      this.answers = answers;
      return;
    }
    this.answers = [];
    app.store.find('users', userId, {
      include: 'masqueradeAnswers'
    }).then(() => {
      this.answers = this.attrs.user.masqueradeAnswers() || [];
      m.redraw();
    });
  }
}
flarum.reg.add('fof-masquerade', 'forum/panes/ProfilePane', ProfilePane);